export default __webpack_public_path__ + "static/media/background_start.b8d6c36a.jpg";